<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title PDF Dokumenteninhalte
    .sub-headline Hier können Sie alle PDF Dokumenteninhalte verwalten.

    p.margin-top In den jeweiligen Dokumenten können Sie flexibel alle Texte nach Belieben anpassen. Sollten Sie Module ändern wollen, so 
    a(href="mailto:team@fewoboss.de") kontaktieren Sie gerne das fewoboss-Team
    |.

    .rent-object-features-wrapper.margin-top
      b-tabs(v-model="activeTab")
        b-tab-item(icon="tag-outline" label="Angebot" value="offer")
          .documents
            .document(v-for="rentObjectType in rentObjectTypes" v-if="rentObjectType.isBookable")
              .card
                .top
                  b-icon(:icon="rentObjectType.icon" size="is-medium")
                .padding.main
                  .label Angebotsvorlage für {{rentObjectType.name}}
                  ptemplate(v-if="!rentObjectType.offerDocumentContentId")
                    p - keine Vorlage ausgewählt -
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Auswählen
                  template(v-else)
                    p "{{rentObjectType.offerDocumentContent.name}}"
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Austauschen
                      b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: rentObjectType.offerDocumentContent.id}})") Öffnen
          .breaker
          b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: 'offer'}})") Neuer Dokumenteninhalt
          .documents.margin-top
            .document(v-for="documentContent in documentContents" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: documentContent.id}})")
              .card
                .delete-btn(v-if="documentContent.offerRentObjectTypes.length === 0")
                  b-button(type="is-text" icon-left="close" @click.stop="deleteDocumentContent(documentContent)")
                .top
                  b-icon(icon="file-document-outline" size="is-medium")
                .padding.main
                  .label Angebotsvorlage
                  p "{{documentContent.name}}"
        b-tab-item(icon="file-document-outline" label="Mietvertrag" value="contract")
          .documents
            .document(v-for="rentObjectType in rentObjectTypes" v-if="rentObjectType.isBookable")
              .card
                .top
                  b-icon(:icon="rentObjectType.icon" size="is-medium")
                .padding.main
                  .label Mietvertragsvorlage für {{rentObjectType.name}}
                  template(v-if="!rentObjectType.contractDocumentContentId")
                    p - keine Vorlage ausgewählt -
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Auswählen
                  template(v-else)
                    p "{{rentObjectType.contractDocumentContent.name}}"
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Austauschen
                      b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: rentObjectType.contractDocumentContent.id}})") Öffnen
          .breaker
          b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: 'contract'}})") Neuer Dokumenteninhalt
          .documents.margin-top
            .document(v-for="documentContent in documentContents" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: documentContent.id}})")
              .card
                .delete-btn(v-if="documentContent.contractRentObjectTypes.length === 0")
                  b-button(type="is-text" icon-left="close" @click.stop="deleteDocumentContent(documentContent)")
                .top
                  b-icon(icon="file-document-outline" size="is-medium")
                .padding.main
                  .label Mietvertragsvorlage
                  p "{{documentContent.name}}"
        b-tab-item(icon="file-cancel-outline" label="Stornorechnung" value="cancelInvoice")
          .documents
            .document(v-for="rentObjectType in rentObjectTypes" v-if="rentObjectType.isBookable")
              .card
                .top
                  b-icon(:icon="rentObjectType.icon" size="is-medium")
                .padding.main
                  .label Stornierungsvorlage für {{rentObjectType.name}}
                  template(v-if="!rentObjectType.cancelInvoiceDocumentContentId")
                    p - keine Vorlage ausgewählt -
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Auswählen
                  template(v-else)
                    p "{{rentObjectType.cancelInvoiceDocumentContent.name}}"
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Austauschen
                      b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: rentObjectType.cancelInvoiceDocumentContent.id}})") Öffnen
          .breaker
          b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: 'cancelInvoice'}})") Neuer Dokumenteninhalt
          .documents.margin-top
            .document(v-for="documentContent in documentContents" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: documentContent.id}})")
              .card
                .delete-btn(v-if="documentContent.cancelInvoiceRentObjectTypes.length === 0")
                  b-button(type="is-text" icon-left="close" @click.stop="deleteDocumentContent(documentContent)")
                .top
                  b-icon(icon="file-document-outline" size="is-medium")
                .padding.main
                  .label Stornierungsvorlage
                  p "{{documentContent.name}}"
        b-tab-item(icon="reminder" label="Erinnerung" value="paymentReminder1")
          .documents
            .document(v-for="rentObjectType in rentObjectTypes" v-if="rentObjectType.isBookable")
              .card
                .top
                  b-icon(:icon="rentObjectType.icon" size="is-medium")
                .padding.main
                  .label Erinnerungsvorlage für {{rentObjectType.name}}
                  template(v-if="!rentObjectType.paymentReminder1DocumentContentId")
                    p - keine Vorlage ausgewählt -
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Auswählen
                  template(v-else)
                    p "{{rentObjectType.paymentReminder1DocumentContent.name}}"
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Austauschen
                      b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: rentObjectType.paymentReminder1DocumentContent.id}})") Öffnen
          .breaker
          b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: 'paymentReminder1'}})") Neuer Dokumenteninhalt
          .documents.margin-top
            .document(v-for="documentContent in documentContents" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: documentContent.id}})")
              .card
                .delete-btn(v-if="documentContent.paymentReminder1RentObjectTypes.length === 0")
                  b-button(type="is-text" icon-left="close" @click.stop="deleteDocumentContent(documentContent)")
                .top
                  b-icon(icon="file-document-outline" size="is-medium")
                .padding.main
                  .label Erinnerungsvorlage
                  p "{{documentContent.name}}"
        b-tab-item(icon="alert-decagram" label="Mahnung" value="paymentReminder2")
          .documents
            .document(v-for="rentObjectType in rentObjectTypes" v-if="rentObjectType.isBookable")
              .card
                .top
                  b-icon(:icon="rentObjectType.icon" size="is-medium")
                .padding.main
                  .label Mahnungsvorlage für {{rentObjectType.name}}
                  template(v-if="!rentObjectType.paymentReminder2DocumentContentId")
                    p - keine Vorlage ausgewählt -
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Auswählen
                  template(v-else)
                    p "{{rentObjectType.paymentReminder2DocumentContent.name}}"
                    .button-wrapper.right.margin-top
                      b-button(@click="selectedRentObjectTypeId = rentObjectType.id; isComponentModalActive = true") Austauschen
                      b-button(type="is-light" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: rentObjectType.paymentReminder2DocumentContent.id}})") Öffnen
          .breaker
          b-button(type="is-light" icon-left="plus" @click="$router.push({name: 'SettingsDocumentContentsNew', params: {pdfType: 'paymentReminder2'}})") Neuer Dokumenteninhalt
          .documents.margin-top
            .document(v-for="documentContent in documentContents" @click="$router.push({name: 'SettingsDocumentContentsEdit', params: {id: documentContent.id}})")
              .card
                .delete-btn(v-if="documentContent.paymentReminder2RentObjectTypes.length === 0")
                  b-button(type="is-text" icon-left="close" @click.stop="deleteDocumentContent(documentContent)")
                .top
                  b-icon(icon="file-document-outline" size="is-medium")
                .padding.main
                  .label Mahnungsvorlage
                  p "{{documentContent.name}}"
        //- b-tab-item(icon="head-cog" label="Eigentümerabrechnung" value="ownerSettlement")
          .document
            .card
              .main.padding
                h2.title.is-6 Demnächst verfügbar

  b-modal(v-model="isComponentModalActive"
          has-modal-card
          :full-screen="false" 
          :can-cancel="true")
    .modal-card(style="width: auto")  
      header.modal-card-head
        p.modal-card-title Dokumenteninhalt auswählen
      section.modal-card-body
        b-table(:data="documentContents"
                      default-sort-direction="asc"
                      default-sort="date"
                      hoverable)
          b-table-column(field='name' label='Name' sortable centered, v-slot="props")
            | {{ props.row.name }}
          b-table-column(field='updatedAt' label='Zuletzt bearbeitet am' sortable, centered, v-slot="props")
            | {{ formatDate(props.row.updatedAt) }}
          b-table-column(label='Aktionen', v-slot="props")
            .button-wrapper
              b-button(type="is-primary" @click="updateRentObjectTypeDocumentContent(props.row.id)") Auswählen
</template>

<script>
import { DateTime } from 'luxon';

export default {
  data() {
    return {
      activeTab: 'offer',
      isComponentModalActive: false,
      selectedRentObjectTypeId: null,
    };
  },
  computed: {
    rentObjectTypes() {
      return this.$store.state.rentObjectTypes.all;
    },
    documentContents() {
      return this.$store.state.documentContents.all.filter(d => d.pdfType === this.activeTab);
    }
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    async updateRentObjectTypeDocumentContent(documentContentId) {
      await this.$store.dispatch("rentObjectTypes/updateDocumentContent", {rentObjectTypeId: this.selectedRentObjectTypeId, documentContentId, pdfType: this.activeTab});
      this.isComponentModalActive = false;
      this.$store.dispatch("rentObjectTypes/findAllFull");
    },
    async deleteDocumentContent(documentContent) {
      this.$buefy.dialog.confirm({
        title: "Inhalt löschen",
        message: `Sind Sie sicher, dass Sie den Inhalt <b>${documentContent.name}</b> löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.`,
        confirmText: "Jetzt löschen",
        cancelText: "Abbrechen",
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          try {
            await this.$store.dispatch("documentContents/delete", {id: documentContent.id});
            await this.$store.dispatch("documentContents/findAll");
          } catch (e) {
            // nothing here
          }
        },
      });
    },
  },
  async mounted() {
    if (this.$route.query.pdfType) this.activeTab = this.$route.query.pdfType;
    this.$store.dispatch("rentObjectTypes/findAllFull");
    await this.$store.dispatch("documentContents/findAll");
  },
};
</script>

<style lang="scss" scoped>
.documents {
  display: flex;
  flex-wrap: wrap;
}
.document {
  width: calc(33% - #{$sm-space});
  margin-right: $sm-space;
  margin-bottom: $sm-space;
  .card {
    overflow: initial;
    position: relative;
    .delete-btn {
      position: absolute;
      top: $xs-space;
      right: $xs-space;
    }
    &:hover {
      color: $primary;
      .label {
        color: $primary;
      }
      .subtitle {
        color: $primary;
      }
      cursor: pointer;
    }
    width: 100%;
    text-align: center;
    .top {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>